import { render, staticRenderFns } from "./UnsubscribeBridge.vue?vue&type=template&id=811556ee&scoped=true"
import script from "./UnsubscribeBridge.vue?vue&type=script&lang=js"
export * from "./UnsubscribeBridge.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeBridge.vue?vue&type=style&index=0&id=811556ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811556ee",
  null
  
)

export default component.exports